module.exports = __webpack_public_path__ + "static/media/qr_logo_square.75f2fda9.png";